import React, { useMemo } from 'react';

import VideoPlayer from 'common/VideoPlayer/VideoPlayer';
import { FlexDiv, GenericDiv, GenericP, GenericSpan, Heading } from 'commonStyles';
import { VideoText, PlayBtn } from '../../../../bizLanding/components/BannerCarousel/BannerCarouselStyle';
import { VideoOverlay } from './cardStyles';
import { logOmniture } from 'UtilityComponents/intergarationUtils';
import { PATHS } from 'AppConstants';

const Card = ({ url, linkDetails, align, heading, description, headingType = 'h2', type, overlayTxt, trackEvent }) => {
	const flexDirection = useMemo(()=>{
		switch (align) {
			case 'left':
				return 'row';
			case 'right':
				return 'row-reverse';
			case 'top':
				return 'column';
			default:
				return 'column-reverse';
		}
	}, []);

	const redirect = (e) => {
		e.preventDefault();
		logOmniture(`${trackEvent}_clicked`, PATHS.TRAVEL_INTEGRATION_LANDING);
		window.location.href = linkDetails.linkUrl;
	};

	return (
		<FlexDiv $direction={flexDirection} bottom_M='50' justify='space-between'>
			{type == 'image' ? <img src={url} width='50%' /> :
			<GenericDiv position='relative' $width='50%' $bg='linear-gradient(to bottom left, #FFE0CB 0%, #FFF 50%)' padding='20px'>
				<VideoPlayer
					$width='100%'
					url={url}
					playing
					controls
					light
					playIcon={<VideoOverlay
						position='absolute'
						align='center'
						justify='center'
						$direction='column'
						height='calc(100% - 40px)'
						$width='calc(100% - 40px)'
						$bg='linear-gradient(180deg, rgba(85, 85, 85, 0.80) 13.92%, rgba(0, 0, 0, 0.80) 42.38%)'>
						<PlayBtn aria-label='play-button' />
						<VideoText>{overlayTxt}</VideoText>
               </VideoOverlay>}
					volume={0.5}
				/>
			</GenericDiv>}
			<GenericDiv $width='calc(50% - 40px)' top_P='24'>
				{heading && <Heading as={headingType}>{heading}</Heading>}
				{description && <GenericP line_height='28px' fsize='18px' bottom_M='24' top_M='8'>{description}</GenericP>}
				{linkDetails &&
				<GenericSpan $cursor='pointer' href={linkDetails.linkUrl} f_weight='900' fsize='16' color='#008CFF' as='a' onClick={redirect}>{linkDetails.linkText}
					{linkDetails.linkIcon && <GenericSpan src={linkDetails.linkIcon} />}
				</GenericSpan>}
			</GenericDiv>
		</FlexDiv>
	);
};

export default Card;
